import react from 'react';
import { FileUpload } from '../../elements/upload';

export const IndexPage: react.FC = () => {
    return <div>
        <FileUpload></FileUpload>
    </div>
}